import { render, staticRenderFns } from "./TabPerfil.vue?vue&type=template&id=7e8b6b6a&scoped=true&"
import script from "./TabPerfil.vue?vue&type=script&lang=js&"
export * from "./TabPerfil.vue?vue&type=script&lang=js&"
import style0 from "./TabPerfil.vue?vue&type=style&index=0&id=7e8b6b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b6b6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContent,VRow,VTab,VTabs})
